let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cVu76")).then(() => parcelRequire('4ZmEb'));